export enum Horizontal {
	Right = 0,
	Left = 1,
}

export enum Vertical {
	Top = -1,
	Bottom = 1,
}
